<div class="table-container">
  <app-scroll-view
    class="scroll-view"
    [vertical]="true"
    [horizontal]="true"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  >
    <table class="table-results" mat-table [dataSource]="_pagedData">
      <ng-container matColumnDef="selection_controls">
        <th mat-header-cell *matHeaderCellDef class="table-header-cell">
          <app-check-box
            [(value)]="allSelected"
            (valueChange)="onSelectAllChangedInternal($event)"
          ></app-check-box>
        </th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          class="table-cell"
          [ngClass]="{ selected: isSelected(i) }"
          (click)="onColumnClick(i)"
        >
          <app-check-box
            [value]="isSelected(i)"
            [readOnly]="true"
          ></app-check-box>
        </td>
      </ng-container>

      <ng-container
        matColumnDef="{{ field.name }}"
        *ngFor="let field of fields"
      >
        <th mat-header-cell *matHeaderCellDef class="table-header-cell">
          {{ field.alias ?? field.name }}
        </th>
        <td
          mat-cell
          *matCellDef="let item; let i = index"
          class="table-cell"
          [ngClass]="{ selected: isSelected(i) }"
          (click)="onColumnClick(i)"
        >
          <ng-template
            [ngTemplateOutlet]="
              isFieldUrl(field) ? itemValueUrlTpl : formatValueTpl
            "
            [ngTemplateOutletContext]="{ value: item[field.name], field }"
          ></ng-template>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="table-header"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
      ></tr>
    </table>
  </app-scroll-view>
</div>

<div class="pagination-row">
  <app-pagination
    [totalCount]="resultList?.length ?? 0"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    (pageIndexChange)="onPageIndexChange($event)"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-pagination>
</div>

<ng-template #itemValueUrlTpl let-field="field" let-value="value">
  <a
    *ngIf="!!value"
    class="link"
    [href]="value"
    target="_blank"
    (click)="$event.stopPropagation()"
  >
    Aceder aqui
  </a>
</ng-template>

<ng-template #formatValueTpl let-value="value" let-field="field">
  {{ value | fieldFormat : field : layer }}
</ng-template>
